import { Input } from "@heroui/react";
import { FilterCard } from "@/components/data-table";

/**
 * Filter component for Warehouse page
 */
const FilterData = ({ table, initialFilters }) => {
    const { filterPanel } = table;
    const { isOpen, pending, setPending, apply, clear } = filterPanel;

    // Handle clear - reset to initial values
    const handleClear = () => {
        setPending(initialFilters);
        clear();
    };

    return (
        <FilterCard isVisible={isOpen} onClear={handleClear} onApply={apply}>
            {/* Nama Supplier */}
            <Input
                label="Nama Supplier"
                placeholder="Cari nama supplier..."
                value={pending.name || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        name: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Alamat */}
            <Input
                label="Alamat"
                placeholder="Cari alamat..."
                value={pending.address || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        address: val,
                    }))
                }
                variant="flat"
                isClearable
            />

            {/* Kontak */}
            <Input
                label="Kontak"
                placeholder="Cari nomor kontak..."
                value={pending.contact || ""}
                onValueChange={(val) =>
                    setPending((prev) => ({
                        ...prev,
                        contact: val,
                    }))
                }
                variant="flat"
                isClearable
            />
        </FilterCard>
    );
};

export default FilterData;
